export default __webpack_public_path__ + "static/vesdk-a1ff4b150a368d0623d4cfd35df6bc9a.png";